import { memo, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import { getEndpointUrl } from "../../Utils/Common";

const AddChoiceGroupDialog = ({ visible, onHide, formElementId, onSuccess }) => {
    const [isLoading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [required, setRequired] = useState(true);
    const [detail, setDetail] = useState('');

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const resetForm = () => {
        setName('');
        setRequired(true);
        setDetail('');
    };

    const onSubmit = async () => {
        if (!formElementId) {
            toast.error("Form element tidak valid.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
            return;
        }
        if (!name.trim()) {
            toast.error("Nama group wajib diisi.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
            return;
        }

        setLoading(true);
        try {
            const payload = {
                form_element_id: formElementId,
                name: name.trim(),
                required: !!required,
                details: detail.trim() ? [detail.trim()] : []
            };

            const res = await fetch(`${getEndpointUrl()}/v2/form_choice`, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesToken}`,
                }),
                body: JSON.stringify(payload)
            });

            const json = await res.json();
            setLoading(false);

            if (json.status === 'ok' && json.results) {
                toast.success("Form choice group berhasil dibuat.", {
                    position: "top-center",
                    autoClose: 2500,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
                onSuccess(json.results);
                resetForm();
                onHide();
            } else {
                toast.error(json.message || "Gagal membuat form choice group.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        } catch (err) {
            setLoading(false);
            toast.error("Terjadi kesalahan jaringan.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        }
    };

    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={visible} onHide={onHide} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isLoading ? "Menyimpan data..." : "Tambah Form Choice Group"}
                    </Modal.Title>
                </Modal.Header>

                {isLoading ? (
                    <div className="d-flex justify-content-center mt-5 mb-5">
                        <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                    </div>
                ) : (
                    <>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nama Group</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Contoh: DILENGKAPI"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="switch"
                                        id="required-switch"
                                        label="Required"
                                        checked={required}
                                        onChange={(e) => setRequired(e.target.checked)}
                                    />
                                </Form.Group>
                                {/* <Form.Group className="mb-3">
                                    <Form.Label>Detail (opsional)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Contoh: Deskripsi dari HOHA"
                                        value={detail}
                                        onChange={(e) => setDetail(e.target.value)}
                                    />
                                    <Form.Text className="text-muted">
                                        Jika diisi, akan dibuat satu detail awal pada group.
                                    </Form.Text>
                                </Form.Group> */}
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onHide}>Batal</Button>
                            <Button variant="primary" onClick={onSubmit}>Simpan</Button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
        </>
    );
};

export default memo(AddChoiceGroupDialog);